export default "__VITE_ASSET__C62wU$1E__"